// extracted by mini-css-extract-plugin
module.exports = {"date":"NotYetForSale_date__8Lp_l","liveSaleStartsContainer":"NotYetForSale_liveSaleStartsContainer__xe3P6"};